import styled from "styled-components";
import {
  EventContentBody,
  EventContentScrollArea,
  EventPageHeader,
  EventPageWrapper,
} from "../../event/shared/page-layout";

export const EventBingoWrapper = EventPageWrapper;

export const PageHeaderArea = EventPageHeader;

export const ContentScrollArea = EventContentScrollArea;

export const ContentBody = EventContentBody;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 35px;
  font-weight: 700;
`;

export const CreateButton = styled.button`
  border: none;
  border-radius: 15px;
  background: #7f25fb;
  color: #fff;
  padding: 12px 32px;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
`;

export const TabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  margin-top: 28px;
  border-bottom: 1px solid #e5e5e5;
`;

export const TabItem = styled.button<{ $selected: boolean }>`
  border: none;
  background: none;
  padding: 0 0 12px;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: ${({ $selected }) => ($selected ? 700 : 500)};
  color: ${({ $selected }) => ($selected ? "#7f25fb" : "#969696")};
  border-bottom: 2px solid
    ${({ $selected }) => ($selected ? "#7f25fb" : "transparent")};
  cursor: pointer;
`;

export const TableSection = styled.div`
  margin-top: 20px;
  flex: 1;
  min-height: 0;
`;
